/* eslint-disable no-sparse-arrays */
import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Link,
  Checkbox,
  Divider,
  Box,
  useTheme,
} from "@mui/material";
import TextfieldNumber from "./../components/TextfieldNumber";
import TitleDescriptionCoupon from "./../components/TitleDescriptionCoupon";
// import { ReactComponent as CouponIcon } from "./../../../assets/images/coupon_icon.svg";
import { ReactComponent as EditBoxIcon } from "./../../../assets/images/edit_box_icon.svg";
import benefitsIcon from "./../../../assets/images/benefits_icon.svg";
// import BenefitsList from "./../components/BenefitsList";
import TableComponent from "./../components/TableComponent";
import calculateRestaurantPayment from "../../../utils/calculateRestaurantPayment";
import costStructure from "../../../constants/costStructure";
import whatsapp_icon from "./../../../assets/images/whatsapp_icon.svg";
import CouponTextfield from "../components/CouponTextfield";
import TryFree from "../try-free";
import ImportantNote from "../important-note";
import { BenefitItem } from "../components/BenefitsList";
import tickRedIcon from "./../../../assets/images/tick_red_icon.svg";

const BenefitsList = ({ additionalCharges = [], isKids = false, others }) => {
  return (
    <Box sx={{ mb: 2 }}>
      {/* Restauarnt */}
      {/* <BenefitItem text="Free three-month trial" /> */}
      <BenefitItem text="Unlimited venue listings on multi-venue plan." />
      <BenefitItem text="Assign Multiple venue managers for each venue" />
      <BenefitItem
        text="Detailed profile and landing page on"
        highlight=" Findmyvenue.com"
      />
      <BenefitItem text="Direct website enquiries" />
      <BenefitItem text="No booking fees or commissions on the platform" />
      <BenefitItem text="Direct access to potential clients" />
      <BenefitItem text="Detailed reporting and analytics" />
      <BenefitItem text="1 x social media post coverage" />
      {/* <BenefitItem text="Digital guided onboarding" /> */}
      {/* <Divider sx={{ borderStyle: "dashed", mb: 2, mt: 2 }} />
			{!isKids && !others && (
				<Box sx={{ display: "flex", alignItems: "center", pl: 2 }}>
					<Typography variant="body1" sx={{ fontWeight: "600", mb: 2 }}>
						Additional Charges
					</Typography>
				</Box>
			)}
			{additionalCharges.map((charge, index) => (
				<BenefitItem
					key={index}
					text={charge.text}
					highlight={charge.highlight}
					isHighlightFirst={true}
				/>
			))} */}
    </Box>
  );
};

function createData(plan, rate, quantity, total) {
  return { plan, rate, quantity, total };
}

function createThirdTableData(description, action) {
  return { description, action };
}

const firstTableHeaders = [
  { label: "Plan Breakdown", key: "plan", align: "left" },
  { label: "Rate", key: "rate", align: "right" },
  {
    label: "Quantity",
    key: "quantity",
    align: "right",
    width: "15%",
  },
  { label: "Total", key: "total", align: "right" },
];

const secondTableHeaders = [
  { label: "", key: "plan", align: "left" },
  { label: "", key: "rate", align: "right" },
  {
    label: "",
    key: "quantity",
    align: "right",
    width: "15%",
  },
  { label: "", key: "total", align: "right" },
];

const thirdTableHeaders = [
  { label: "Description", key: "description", align: "left" },
  { label: "Action", key: "action", align: "right" },
];

function PaymentRestaurantView({ paymentData, handleContinue, user }) {
  const theme = useTheme();
  const [editMode, setEditMode] = useState(false);
  const [withAlcoholNumber, setWithAlcoholNumber] = useState(0);
  const [withoutAlcoholNumber, setWithoutAlcoholNumber] = useState(0);
  const [discount, setDiscount] = useState(0);

  const [calculatedValues, setCalculatedValues] = useState({
    subTotal: 0,
    grandTotal: 0,
    withAlcoholCost: 0,
    withoutAlcoholCost: 0,
    withAlcoholSaving: 0,
    withoutAlcoholSaving: 0,
    withAlcoholRate: 0,
    withoutAlcoholRate: 0,
  });
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    if (paymentData) {
      setWithAlcoholNumber(paymentData.withAlcoholNumber);
      setWithoutAlcoholNumber(paymentData.withoutAlcoholNumber);
    }
  }, [paymentData]);

  useEffect(() => {
    const alcoholNum = paymentData?.withAlcoholNumber ?? withAlcoholNumber;
    const nonAlcoholNum =
      paymentData?.withoutAlcoholNumber ?? withoutAlcoholNumber;
    const updatedValues = calculateRestaurantPayment(alcoholNum, nonAlcoholNum);

    const subtotal = updatedValues.subTotal;

    // Calculate the discount amount
    const discountAmount = (discount / 100) * subtotal;

    // Apply the discount to the subtotal
    const discountedSubtotal = subtotal - discountAmount;

    // Calculate VAT and grand total
    const vatServiceFee = (discountedSubtotal * costStructure.vat) / 100;
    const grandTotal = discountedSubtotal + vatServiceFee;

    // Update the calculated values state
    setCalculatedValues({
      ...updatedValues,
      subTotal: discountedSubtotal,
      grandTotal: grandTotal,
      discountAmount: discountAmount, // Optionally store the discount amount
    });

    // Update localStorage with the latest grand total
    localStorage.setItem("restaurantview", grandTotal.toString());
  }, [
    withAlcoholNumber,
    withoutAlcoholNumber,
    discount,
    costStructure.vat,
    paymentData,
  ]);

  const handleWithAlcoholNumberChange = (event) => {
    setWithAlcoholNumber(Number(event.target.value));
  };

  const handleWithoutAlcoholNumberChange = (event) => {
    setWithoutAlcoholNumber(Number(event.target.value));
  };

  const firstTableRows = paymentData
    ? [
        createData(
          <Typography sx={{ color: "#5e5e5e", fontSize: { xs: "0.8rem" } }}>
            Restaurants with alcohol{" "}
            {/* <span style={{ color: "#039F8D" }}>
              (${calculatedValues.withAlcoholSaving} saved)
            </span> */}
          </Typography>,
          <span className="">{`$${calculatedValues.withAlcoholRate}`}</span>,
          editMode ? (
            <TextfieldNumber
              value={withAlcoholNumber}
              onChange={handleWithAlcoholNumberChange}
            />
          ) : (
            withAlcoholNumber
          ),
          `$${calculatedValues.withAlcoholCost}`
          // "$0"
        ),
        createData(
          <Typography sx={{ color: "#5e5e5e", fontSize: { xs: "0.8rem" } }}>
            Restaurants without alcohol{" "}
            {/* <span style={{ color: "#039F8D" }}>
              (${calculatedValues.withoutAlcoholSaving} saved)
            </span> */}
          </Typography>,
          <span className="">{`$${calculatedValues.withoutAlcoholRate}`}</span>,
          editMode ? (
            <TextfieldNumber
              value={withoutAlcoholNumber}
              onChange={handleWithoutAlcoholNumberChange}
            />
          ) : (
            withoutAlcoholNumber
          ),
          `$${calculatedValues.withoutAlcoholCost}`
          // "$0"
        ),
      ]
    : [];

  const subTotal = calculatedValues.subTotal;
  const vatServiceFee = (subTotal * costStructure.vat) / 100;

  const secondTableRows = paymentData
    ? [
        ...(discount !== 0
          ? [
              createData(
                "Sub Total",
                "",
                "",
                `$${(subTotal / (1 - discount / 100)).toFixed(2)}`
                // "$0"
              ),
              createData(
                "Discount",
                "",
                "",
                `-$${(subTotal / ((100 - discount) / discount)).toFixed(2)}`
                // "$0"
              ),
            ]
          : [
              createData(
                "Sub Total",
                "",
                "",
                `$${subTotal ? subTotal.toFixed(2) : "0"}`
              ),
            ]),
        createData(
          "VAT (5%)",
          "",
          "",
          `$${vatServiceFee ? vatServiceFee.toFixed(2) : "0"}`
        ),
      ]
    : [];

  const grandTotal = calculatedValues.grandTotal;
  const thirdTableRows = paymentData
    ? [
        createThirdTableData(
          <Typography variant="h6">Grand Total</Typography>,
          <Typography>{`$${
            grandTotal ? grandTotal.toFixed(2) : "0"
          }`}</Typography>
        ),
        createThirdTableData(
          <Typography variant="h6" sx={{ fontWeight: "600" }}>
            Pay Now
          </Typography>,
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            ${grandTotal?.toFixed(2)}
          </Typography>
        ),
      ]
    : [];

  const leftBox = (
    <Box
      className="overflow-hidden"
      sx={{
        display: "flex",
        height: "100%",
        flexDirection: { xs: "column", md: "column" }, // Stack items vertically on mobile
        alignItems: "center",
        marginInline: { xs: "none", lg: "auto" },
        paddingX: { xs: 1, md: 2 },
        flexGrow: 1,
        width: { xs: "100%", md: "100%" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "100%" },
          border: `2px solid ${theme.palette.grey.border}`,
          backgroundColor: theme.palette.white,
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          minHeight: "200px",
          pl: 2,
          pr: 2,
        }}
      >
        <Box
          className="justify-between items-center md:px-4 mt-3"
          sx={{
            display: "flex",
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            // px: 4,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              textAlign: "left",
              // py: 2,
              fontSize: { xs: "13px", md: "20px" },
            }}
          >
            Venue Plan
          </Typography>
          <Button
            variant="text"
            startIcon={<EditBoxIcon />}
            onClick={() => setEditMode(!editMode)}
            sx={{
              color: "primary.main",
              textTransform: "none",
              m: 0,
            }}
          >
            {editMode ? "Save Plan" : "Edit Plan"}
          </Button>
        </Box>

        <Box
          sx={{
            width: "95%",
            mt: -2.8,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Divider sx={{ width: "95%", mt: 2 }} />
        </Box>

        <TableComponent
          headers={firstTableHeaders}
          rows={firstTableRows}
          showHeader={true}
        />

        <Divider sx={{ borderStyle: "dashed" }} />

        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            mt: 2,
            mb: 2,
          }}
        >
          {(user?.paymentStatus === undefined ||
            user?.trialStatus === "remaining" ||
            user?.paymentStatus === "Active") && (
            <CouponTextfield flag={true} />
          )}
        </Box> */}

        <Divider sx={{ borderStyle: "dashed" }} />

        <TableComponent
          headers={secondTableHeaders}
          rows={secondTableRows}
          showHeader
        />

        <Box
          sx={{
            width: "100%",
            mt: -2.8,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Divider sx={{ width: "95%", mt: 3, mb: -1 }} />
        </Box>
        <TableComponent headers={thirdTableHeaders} rows={thirdTableRows} />
      </Box>
    </Box>
  );

  const rightBox = (
    <Box
      sx={{
        width: { xs: "100%", md: "40%" },
        border: `2px solid ${theme.palette.grey.border}`,
        backgroundColor: theme.palette.white,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        px: 4,
      }}
    >
      {/* For Icon + Plan Benefits*/}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.primary.light,
            display: "flex",
            justifyContent: "center",
            borderRadius: "8px",
            mr: 2,
          }}
        >
          <img
            src={benefitsIcon}
            alt="Benefits Icon"
            style={{
              width: "40px",
              height: "40px",
            }}
          />
        </Box>
        <Typography
          variant="h5"
          color={theme.palette.primary.main}
          fontWeight={500}
          sx={{ fontSize: "1.6rem" }}
        >
          Plan Benefits
          {/* Restaurants -> venus case */}
        </Typography>
      </Box>
      {/* For Base Charge*/}
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
          ml: 3,
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="body1"
          color={theme.palette.grey.dark}
          fontWeight={500}
        >
          Base Charge: $1,500/Restaurant
        </Typography>
      </Box> */}
      <BenefitsList
        additionalCharges={[
          {
            text: "$1000/60 - sec video",
          },
          {
            text: "$600/professional photoshoot",
          },
          {
            text: "$300/10 branded images",
          },
          {
            text: "$400/house alcohol",
          },
          {
            text: "$500/permium alcohol",
          },
        ]}
      />
    </Box>
  );

  const bottomBox = (
    <Box
      // className="bg-red-700"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pl: 4,
        mt: 2,
      }}
    >
      {/* <ImportantNote /> */}
      {/* TERMS AND CONDITIONS */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
          flexDirection: { xs: "rows", md: "row" },
        }}
      >
        <Checkbox
          color="primary"
          checked={isChecked}
          onChange={handleCheckboxChange}
          required
        />
        <Box sx={{ textAlign: "left" }}>
          <Typography
            sx={{ fontSize: { xs: "12px", lg: "14px" } }}
            style={{ color: theme.palette.grey.text }}
          >
            {"I agree to all "}
            <Link href="/terms&conditions" target="_blank">
              <span
                className="tracking-[1px] cursor-pointer"
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "400",
                }}
              >
                Terms & Conditions
              </span>
            </Link>
            {" and "}
            <Link href="/cancellation-policy" target="_blank">
              <span
                className="tracking-[1px]"
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "400",
                }}
              >
                Cancellation policy
              </span>
            </Link>
            {" including usage of cookies"}
          </Typography>
        </Box>
      </Box>
      {/* <ImportantNote /> */}

      <Button
        type="submit"
        variant="contained"
        size="large"
        onClick={handleContinue}
        disabled={
          !isChecked ||
          (paymentData?.withAlcoholNumber === 0 &&
            paymentData?.withoutAlcoholNumber === 0)
        }
        sx={{
          mb: { xs: 1, md: 3 },
          borderRadius: "8px",
          width: { xs: "80%", lg: "400px" },
          margin: "auto",
          mt: 2,
          backgroundColor: isChecked
            ? theme.palette.primary.main
            : theme.palette.grey.border,
          textTransform: "none",
        }}
      >
        {user?.paymentStatus == "Cancelled" ? (
          <>Start Your Plan</>
        ) : (
          <>Continue</>
        )}
      </Button>

      {/* Whatsapp related Text */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          fontSize: { xs: "12px", md: "14px" },
          letterSpacing: "0.5px",
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <img
          src={whatsapp_icon}
          alt="Whatsapp"
          style={{ height: 22, width: 22, pl: "5px" }}
        />
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.grey.text,
            fontWeight: "500",
          }}
        >
          <span>For any queries </span>
          <Link target="_blank" href="/contact" sx={{ textDecoration: "none" }}>
            <span
              style={{
                textTransform: "none",
                fontWeight: "700",
                color: theme.palette.primary.main,
              }}
            >
              contact us
            </span>
          </Link>
          <span> here—we’re here to help!</span>
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      className="w-full"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.white,
        borderRadius: theme.shape.borderRadius,
        width: { xs: "100%", sm: "80%", md: "100%" },
        pl: 2,
      }}
    >
      <TitleDescriptionCoupon
        title={"Take a look at our plan suitable for your needs! "}
        description={"We found this plan to be best suited for your needs"}
      />
      <Box
        sx={{
          width: "100%",
          heigth: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "flex-start" },
          ml: 2,
        }}
      >
        {/* <Box sx={{ pl: 3, pr: 2, width: "100%", border: "none", boxShadow: 0 }}>
          <TryFree />
        </Box> */}
      </Box>
      <Box
        // className="bg-red-700"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          // alignItems: { xs: "center", md: "flex-start" },
          alignItems: "stretch",
          mt: 1,
          pl: 2,
          flexGrow: 1,
        }}
      >
        {leftBox}
        {rightBox}
      </Box>
      {bottomBox}
    </Box>
  );
}

export default PaymentRestaurantView;
